/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/paymentrequests/$paymentRequestId/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/payments/requests/$paymentRequestId/edit',
      params: { paymentRequestId: params.paymentRequestId } as never,
      statusCode: StatusCodes.MOVED_PERMANENTLY,
    })
  },
})
